import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Paper, Typography } from '@mui/material';
import { Link } from 'components/common/Link';
import { useOrganisationPersonalWebshop } from 'hooks/useOrganisationPersonalWebshop';
import { useServerTranslation } from 'hooks/useServerTranslation';

import { useRouter } from 'next/router';
import useUser from 'stores/useCustomer';
import { colors } from 'styles/theme/colors';
import { useNavigation } from '../../../../../hooks/useNavigation';

export function ConsultantCta() {
    const isUserLoggedIn = useUser((state) => state.useLoggedIn());
    const { isConsultantRoute } = useOrganisationPersonalWebshop();

    if (isUserLoggedIn) {
        return null;
    }

    if (isConsultantRoute) {
        return (
            <ConsultantLoginOrSignupButtons />
        );
    }

    return (
        <GuestFindConsultant />
    );
}

function GuestFindConsultant() {
    const { t } = useServerTranslation();

    const { shop } = useNavigation();

    return (
        <>
            <Paper
                sx={{
                    marginTop: { sm: 0, md: 2 },
                    marginBottom: 2,
                    padding: 1.5,
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    boxShadow: 'unset',
                    backgroundColor: colors.corePink,
                    border: 'none',
                    color: colors.pink2,
                }}
            >
                <Typography fontWeight={300} data-testid="guest-find-consultant">
                    {t('product.contact-consultant-interest')}
                </Typography>
            </Paper>
            <Button
                title={t('product.find-consultant')}
                variant="order"
                LinkComponent={Link}
                href={shop.findconsultant}
                fullWidth
                sx={{ whiteSpace: 'nowrap' }}
                aria-label={t('product.find-consultant')}
                data-testid="find-consultant-button"
            >
                <SearchIcon />
                {t('product.find-consultant')}
            </Button>
        </>
    );
}

function ConsultantLoginOrSignupButtons() {
    const { t } = useServerTranslation();
    const router = useRouter();

    const { system, shop } = useNavigation();

    return (
        <>
            <Box sx={{
                display: 'flex',
                rowGap: 1,
                columnGap: 3,
            }}
            >
                <Button
                    title={t('product.log-in')}
                    variant="order"
                    LinkComponent={Link}
                    href={system.userLoginCallback(encodeURIComponent(router.asPath))}
                    fullWidth
                    sx={{ whiteSpace: 'nowrap', maxWidth: '120px' }}
                    aria-label={t('product.log-in')}
                    data-testid="log-in-button"
                    key="LogInButton"
                >
                    {t('product.log-in')}
                </Button>
                <Button
                    title={t('product.become-customer')}
                    variant="order"
                    LinkComponent={Link}
                    href={shop.consultantProfile}
                    fullWidth
                    sx={{ whiteSpace: 'nowrap', maxWidth: '120px' }}
                    aria-label={t('product.become-customer')}
                    data-testid="become-customer-button"
                    key="BecomeCustomerButton"
                >
                    {t('product.become-customer')}
                </Button>
            </Box>
        </>
    );
}
